import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
export default function LandingHome() {
    const { t } = useTranslation();
    return (
        <section className="relative landinghome mb-[20px]">
            <div className="container h-[100vh] flex flex-col justify-center gap-[20px]">
                <div className="btmAni2000 flex items-center gap-[8px]">
                    <span className="h-[2px] w-[25px] bg-[#A0642E]"></span>
                    <div className="font-bold text-white">{t("PROFESSIONAL PHOTOGRAPHER")}</div>
                </div>
                <div className="btmAni25002 font-bold text-white text-[55px]">{t("ABOUD ABU ALRUB")}</div>
                <p className="w-100 border-left-none-right btmAni20002 text-white text-[20px] w-[400px] border-l-2 border-[#a0642e] px-3">
                    {t("Every frame tells a story. Let’s create timeless memories together")}
                </p>
                <div className="btmAni25002">
                    <img className="w-[20%] h-[100%]" src={require("../../assets/logo/logos-3.svg").default} alt="" />
                </div>
                <Link className="btmAni3000 w-fit bg-[#016E82] text-white px-[20px] py-[8px] rounded font-bold capitalize" to={"/portfolio"}>{t("Explore Gallery")}</Link>
                <div className="l-res-40 absolute bottom-4 left-1/2 flex flex-col items-center justify-center text-center gap-[5px]">
                    <div className="btmArrowAnimation w-11 h-11 bg-white flex items-center justify-center rounded-full border-4 border-[#016e82]">
                        <img className="w-[20px] h-[20px]" src={require("../../assets/icons/bottom-arrow.svg").default} alt="" />
                    </div>
                    <div className="text-white">Scroll Down</div>
                </div>
            </div>
        </section>
    );
}